module.exports = __webpack_public_path__ + "img/xk_logo@2x.f021a8d7.png";